// ResetPassword.js
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// import { resetPassword } from "../../../api/user"; // Import your API function for password reset
import { toast } from "react-toastify";
import { forgotPassword } from "../api/user";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../images/logo.png";

function Password() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();

    // Basic email validation
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      toast.error("Invalid email address");
      return;
    }

    setLoading(true);

    try {
      const response = await forgotPassword({ email: email });
      if (response.data.status === 200) {
        // console.log(response,"200");
        toast.success(response.data.message);
        navigate("/auth/login");
      } else if (response.data.status === 400) {
        toast.error(response.data.message);
      }
      // Call your API function for password reset
      // Example: const response = await resetPassword(email);

      // Handle the response and show appropriate messages
      // Example: toast.success(response.data.message);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to reset password. Please try again.");
    }

    setLoading(false);
  };

  return (
    <>
            <div className="flex min-h-screen">
  <div className="flex justify-center w-full flex-col md:flex-row">

    {/* Left Side — Branding / Logo Section */}
    <div className="md:bg-primaryColor md:min-h-screen flex flex-wrap md:w-1/2">
      <div className="items-center text-center flex flex-col relative justify-center mx-auto mt-2">
        <img
          src={"/qushi_logo.png"}
          alt="Logo Login"
          className="md:w-48 w-48 mx-auto"
        />
      </div>
    </div>
      <div className="flex flex-col md:w-1/2 items-center justify-center">
          <div className="w-full  loginWrapper flex flex-col lg:w-3/5 max-w-md lg:px-10 md:px-5 px-5 pt-2">
            <img
              src={"/qushi_logo.png"}
              alt="Logo Login"
              className="md:w-32 mt-4 w-32 mx-auto"
            />
          </div>
          <div className=" md:block font-bold mt-4 self-center text-xl sm:text-3xl text-gray-800">
            {t("Forgot Password")}
          </div>
          <div className="hidden md:block relative mt-4 h-px bg-gray-300">
            <div className="absolute left-0 top-0 flex justify-center w-full mt-2"></div>
          </div>
          <form onSubmit={handleResetPassword} className="w-full max-w-md mt-4">
            <div className="mb-4">
              <label className="block text-gray-600 text-sm mb-2">
                Enter your Email
              </label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="email@example.com"
              />
            </div>
            <div className="mb-4">
              <button
                type="submit"
                disabled={loading}
                className="bg-primaryColor text-white py-2 px-4 rounded focus:outline-none"
              >
                {loading ? t("processing") + "...." : t("reset")}
              </button>
            </div>
          </form>
        </div>
      </div>
      </div>
    </>
  );
}

export default Password;
